export default class FormId {
	constructor(formId) {
		this.id = formId.id
		this.officeId = formId.officeId
		this.year = formId.year
	}

	static createFromString(formIdString) {
		const rawArray = formIdString.split('-')
		return new FormId({id: rawArray[2], officeId: rawArray[1], year: rawArray[0]})
	}

	toString() {
		return this.year + '-' + this.officeId + '-' + this.id
	}

	toObject() {
		return { id: this.id, year: this.year, officeId: this.officeId }
	}
}